

import { makeStyles } from 'tss-react/mui';


export const useNotAllowedAreaStyles = makeStyles<{ height: number }>()((theme, props) => ({
  root: {
    width: '100%',
    height: `${props.height}px`,
    position: 'absolute',
    top: 0,
    left: 0,
    cursor: 'not-allowed',
  },
}));


export const NotAllowedArea: React.VFC<{ height: number }> = (props) => {
  const { classes } = useNotAllowedAreaStyles(props, { props });

  return (
    <div className={classes.root} />
  );
};
